module.exports = __webpack_public_path__ + "1f85fe92a61d6261002be73dcecf887a.svg";